import { Link, useLocation, useNavigate } from 'react-router-dom'
import styles from './styles.module.css'
import { useEffect } from 'react'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../global/components/buttons/secondary-button/SecondaryButton'
import {
  TECH_ASSISTANT_NAMES,
  TECH_ASSISTANT_PATHS,
} from '../../global/constants/technician-assistant'

const lastTabPathKey = 'lastTechAssistantPath'
const BASE_PATH = '/technician-assistant'
const PATHS = {
  AI_ASSISTANT: {
    NAME: TECH_ASSISTANT_NAMES.aiAssistant,
    PATH: TECH_ASSISTANT_PATHS.aiAssistant,
  },
  EVALUATIONS: {
    NAME: TECH_ASSISTANT_NAMES.evaluations,
    PATH: TECH_ASSISTANT_PATHS.evaluations,
  },
  CONVERSATION_LOGS: {
    NAME: TECH_ASSISTANT_NAMES.conversationLogs,
    PATH: TECH_ASSISTANT_PATHS.conversationLogs,
  },
}
const DEFAULT_PATH = PATHS.AI_ASSISTANT.PATH

function TabChooser() {
  const navigate = useNavigate()

  const links = [
    {
      name: PATHS.AI_ASSISTANT.NAME,
      path: PATHS.AI_ASSISTANT.PATH,
    },
    {
      name: PATHS.EVALUATIONS.NAME,
      path: PATHS.EVALUATIONS.PATH,
    },
    {
      name: PATHS.CONVERSATION_LOGS.NAME,
      path: PATHS.CONVERSATION_LOGS.PATH,
    },
  ]

  const activePath = useLocation().pathname

  const noActivePath = activePath === BASE_PATH

  useEffect(() => {
    if (noActivePath) {
      const lastPath = localStorage.getItem(lastTabPathKey)
      navigate(lastPath || DEFAULT_PATH)
    } else {
      const pathToSave =
        links.find((link) => link.path === activePath)?.path || DEFAULT_PATH
      localStorage.setItem(lastTabPathKey, pathToSave)
    }
  }, [noActivePath, navigate])

  return (
    <div className={styles.buttonsHolder}>
      {links.map((link, idx) =>
        link.path === activePath ? (
          <Link
            className={styles.link}
            to={link.path}
            key={idx}
          >
            <PrimaryButton
              buttonName={link.name}
              onClick={() => {}}
              style={{ width: 'max-content', height: 'max-content' }}
            />
          </Link>
        ) : (
          <Link
            className={styles.link}
            to={link.path}
            key={idx}
          >
            <SecondaryButton
              buttonName={link.name}
              onClick={() => {}}
              style={{ width: 'max-content', height: 'max-content' }}
            />
          </Link>
        ),
      )}
    </div>
  )
}

export default TabChooser
